import type { VariantTypeCheckbox } from './types'

type VariantFilterType = {
  [key: string]: {
    type: VariantTypeCheckbox
    defaultNumberOpts?: number
  }
}

export const variantsFilter: VariantFilterType = {
  Tamanho: {
    type: 'default',
  },
  Promoção: {
    type: 'default',
  },
  Esporte: {
    type: 'default',
  },
  Entrega: {
    type: 'default',
  },
  'Tipo de montagem': {
    type: 'default',
  },
  Categoria: {
    type: 'default',
  },
  Gênero: {
    type: 'default',
  },
  Idade: {
    type: 'default',
  },
  'Cor predominante': {
    type: 'color',
    defaultNumberOpts: 10,
  },
  Avaliações: {
    type: 'starts',
  },
  Marca: {
    type: 'default',
  },
  Condições: {
    type: 'default',
  },
  'Marca própria': {
    type: 'default',
  },
}

export const colorConfig: { [key: string]: string } = {
  cinza: '#848484',
  preto: '#000',
  prata: '#DADADA',
  roxo: '#AC45EB',
  laranja: '#FF600A',
  azul: '#007DBC',
  vermelho: '#EE0303',
  verde: '#2CAB0D',
  marrom: '#844F00',
  branco: '#FFFFFF',
  amarelo: '#F9D82C',
  rosa: '#E861CA',
  'n/a': '',
}
